import { apiClient } from './api';

const draftService = {
  getDrafts: async () => {
    const response = await apiClient.get('/drafts');
    return response.data;
  },

  saveDraft: async (draftData) => {
    const response = await apiClient.post('/drafts', draftData);
    return response.data;
  },

  deleteDraft: async (id) => {
    const response = await apiClient.delete(`/drafts/${id}`);
    return response.data;
  }
};

export default draftService;
